import React, { Component } from "react";
import { Grid, Row, Col, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
// react component used to create alerts
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import "react-select/dist/react-select.css";
import decode from 'jwt-decode';
import FileSaver from 'file-saver';
//Full calendar
import $ from "jquery";
import "fullcalendar/dist/fullcalendar.js";
import "fullcalendar/dist/locale/es.js";
import Card from "../../components/Card/Card.jsx";
import Checkbox from '../../elements/CustomCheckbox/CustomCheckbox.jsx';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalCalendario from './ModalCalendario.jsx';
import CalendarServices from "../../services/CalendarServices";
import ModalEvento from './ModalEvento.jsx';
import ModalExport from './ModalExport.jsx';
import ModalImport from './ModalImport.jsx';
import "./custom.css";

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      singleSelect: null,
      modalCreate: false,
      calendariosUser: null,
      calendariosPublic: null,
      calendarData: null,
      currentEvent: null,
      currentCalendar: null,
      userId: decode(localStorage.getItem('id_token')).id,
    };
    this.hideAlert = this.hideAlert.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.saveCalendar = this.saveCalendar.bind(this);
    this.generateCheckbox = this.generateCheckbox.bind(this);
    this.saveUserCalendar = this.saveUserCalendar.bind(this);
    this.generateOptions = this.generateOptions.bind(this);
    this.openEventModal = this.openEventModal.bind(this);
    this.updateEvents = this.updateEvents.bind(this);
    this.getEventById = this.getEventById.bind(this);
    this.confirmDeleteCalendar = this.confirmDeleteCalendar.bind(this);
    this.deleteUserCalendar = this.deleteUserCalendar.bind(this);
    this.exportCalendar = this.exportCalendar.bind(this);
    this.getAllDataAtOnce = this.getAllDataAtOnce.bind(this);
    this.importCalendar = this.importCalendar.bind(this);
    this.calendarServices = new CalendarServices();
  }

  componentWillMount() {
    this.getAllDataAtOnce();
  }

  getAllDataAtOnce() {
    this.setState({calendariosPublic: null, calendariosUser: null, calendarData: null});
    this.calendarServices.getPublicCalendars()
      .then(res => {
        this.setState({calendariosPublic: res.calendars});
        this.calendarServices.getUserCalendars()
          .then(res => {
            this.setState({calendariosUser: res.calendarios});
            this.calendarServices.getDrawCalendar()
              .then(res => {
                this.setState({calendarData: res});
                this.updateEvents(res);
              })
              .catch(err => {
                this.errorAlert(
                  <div>
                    Ocurrio un error mientras se obtenia la informacion de los calendarios del usuario, el servidor ha
                    devuelto la siguiente información: <p>{err.message}</p>
                  </div>);
              });
          })
          .catch(err => {
            this.errorAlert(
              <div>
                Ocurrio un error se obtenia la informacion de los calendarios públicos, el servidor ha
                devuelto la siguiente información: <p>{err.message}</p>
              </div>);
          });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error se obtenia la informacion del calendario, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }
  openEventModal(start) {
    const daysAndTimes = {
      fechainicio: start.split('T')[0],
      horainicio: start.split('T')[1] ? start.split('T')[1] : '',
      fechafin: start.split('T')[0],
      horafin: start.split('T')[1] ? start.split('T')[1] : '',
    }
    this.setState({modalEvent: true, daysAndTimes});
  }
  updateEvents(events){
    const reactMainComponent = this; // necesario para llamar a la funcion desde fullcalendar
      $("#calendar").fullCalendar("destroy");
      $("#calendar").fullCalendar({
        eventSources: events,
        header: { right: "today prev,next month,agendaWeek,agendaDay" },
        navLinks: true, // can click day/week names to navigate views
        selectable: true,
        selectHelper: true,
        select: function(start) {
          reactMainComponent.openEventModal(start.format());
          $('#calendar').fullCalendar('unselect');
        },
        editable: true,
        eventLimit: true, // allow "more" link when too many events
        eventClick: function(calEvent, jsEvent, view) {
          reactMainComponent.getEventById(calEvent.id);
        }
      });
  }

  getEventById(id){
    this.calendarServices.getEventById(id)
      .then(res => {
        this.setState({currentEvent: res.evento, modalEvent: true});
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error al guardar obtener la información del evento, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }

  saveCalendar(calendario) {
    this.calendarServices.postCalendar(calendario)
      .then(res => {
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Calendario guardado!</div>), 10);
        this.setState({modalCreate: false, currentCalendar: null});
        this.getAllDataAtOnce();
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error al guardar el calendario, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }

  editCalendar(item) {
    const calendario = {
      eventtextcolor: item.eventtextcolor,
      eventbackgroundcolor: item.eventbackgroundcolor,
      nombre: item.nombre,
      publico: parseInt(item.publico, 10) ? true : false,
      checked: parseInt(item.checked, 10) ? true : false,
      todoeldia: parseInt(item.todoeldia, 10) ? true : false,
      id: item.id,
    }
    this.setState({modalCreate: true, currentCalendar: calendario});
  }

  generateCheckbox() {
    const html = this.state.calendariosUser.map((item, index) => {
      const propio = parseInt(item.propio, 10);
      return (
        <tr key={index}>
          <td style={{textAlign: 'left', width: '90%'}}>
            <Checkbox
              style={{width: '100%', textAlign: 'left'}}
              number={index}
              label={item.nombre}
              colorbox={item.eventbackgroundcolor}
              isChecked={parseInt(item.checked, 10)}
              handleOnChange={(e) => this.saveUserCalendar(e, item.id, item.calendariousuarioid, item.propio)}
            />
          </td>
          <td style={{width: '10%'}}>
            {propio ?
              <div style={{paddingTop: 5}}>
                <Button simple bsStyle="warning" onClick={() => this.editCalendar(item)}>
                  <i className="fa fa-edit"></i>
                </Button>
                <Button simple bsStyle="danger" onClick={() => this.confirmDeleteCalendar(propio, item.id)}>
                  <i className="fa fa-ban"></i>
                </Button>
              </div> :
              <div style={{paddingTop: 5}}>
                <Button simple bsStyle="danger" onClick={() => this.confirmDeleteCalendar(propio, item.calendariousuarioid)}>
                  <i className="fa fa-ban"></i>
                </Button>
              </div>
            }
          </td>
        </tr>
      );
    });
    return (
      <Table responsive>
        <tbody>
          {html}
        </tbody>
      </Table>
    );
  }

  confirmDeleteCalendar(propio, id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Eliminar Calendario"
          onConfirm={() => this.deleteUserCalendar(propio, id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="warning"
          confirmBtnText="Si!"
          cancelBtnText="Cancelar"
          showCancel
        >
          Desea eliminar el calendario seleccionado?
          {propio ?
            <p>
              Todos los eventos relacionados a este calendario serán eliminados.
              En caso de que este calendario sea público, los demás usuarios dejaran de verlo en sus listas
            </p> :
            null
          }
        </SweetAlert>
      )
    });
  }

  deleteUserCalendar(propio, id) {
    this.calendarServices.deleteUserCalendar(propio, id)
    .then(res => {
      this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Calendario removido!</div>), 10);
      this.setState({alert: null});
      this.getAllDataAtOnce();
    })
    .catch(err => {
      this.errorAlert(
        <div>
          Ocurrio un error mientras se eliminaba el calendario, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>);
    });
  }

  generateOptions() {
    const html = this.state.calendariosPublic.map((item) => {
      return {value: item.id, label: item.nombre};
    });
    return html;
  }

  saveUserCalendar(checked, calendarioId, calendarioUsuarioId, propio) {
    const userCalendar = {
      calendarioid: calendarioId,
      userid: this.state.userId,
      checked: checked ? 1 : 0,
      id: calendarioUsuarioId,
    };
    if (parseInt(propio, 10)) {
      this.calendarServices.setOwnCalendarChecked(checked, calendarioId)
      .then(res => {
        this.getAllDataAtOnce();
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error al actualizar la vista, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
    } else {
      this.calendarServices.saveUserCalendar(userCalendar)
      .then(res => {
        this.getAllDataAtOnce();
        })
        .catch(err => {
          this.errorAlert(
            <div>
              Ocurrio un error al actualizar la vista, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>);
          });
    }
  }

  importCalendar(data) {
    this.calendarServices.importCalendar(data)
    .then(res => {
      console.log(res);
      this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Calendario importado!</div>), 10);
      this.getAllDataAtOnce();
      this.setState({modalImport: false});
    })
    .catch(err => {
      this.errorAlert(
        <div>
          Ocurrio un error al exportar el calendario, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>);
    });
  }

  exportCalendar(exported) {
    this.calendarServices.exportCalendar(exported)
    .then(res => {
      FileSaver.saveAs(res, `${exported.start} -- ${exported.end}.csv`);
    })
    .catch(err => {
      this.errorAlert(
        <div>
          Ocurrio un error al exportar el calendario, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>);
    });
  }

  render() {
    if (!this.state.calendariosUser || !this.state.calendariosPublic || !this.state.calendarData) {
      return (<div className="main-content"></div>);
    }
    return (
      <div className="main-content calendar">
        {this.state.alert}
        <Grid fluid>
          <Row>
            <Col md={4}>
              <Card
                content={
                  <div>
                    <div style={{ textAlign: "left", paddingBottom: 5 }} className="visible-xs-block">
                      <Button bsStyle="primary" bsSize="sm" fill wd block onClick={() => this.setState({modalCreate: true})}>
                        Crear Calendario
                      </Button>
                    </div>
                    <div style={{ textAlign: "right", paddingBottom: 5 }} className="hidden-xs">
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({modalCreate: true})}>
                        Crear Calendario
                      </Button>
                    </div>
                    <div className="eventsSelect">
                      <Row>
                        <Col md={12} style={{paddingRight:5}}>
                          <Select
                            placeholder="Agregar"
                            name="usersCalendar"
                            value={this.state.singleSelect}
                            options={this.generateOptions()}
                            onChange={(item) => this.saveUserCalendar(1, item.value, null, 0)}
                          />
                        </Col>
                      </Row>
                      <Row>
                        {this.generateCheckbox()}
                        <Col md={12} lg={6} sm={6} xs={12}>
                          <Button simple bsSize="sm" fill block onClick={() => this.setState({modalImport: true})} style={{ marginBottom: 5 }}>
                            <i className="fa fa-upload hidden-xs"></i> Importar
                          </Button>
                        </Col>
                        <Col md={12} lg={6} sm={6} xs={12}>
                          <Button simple bsSize="sm" fill block onClick={() => this.setState({modalExport: true})} style={{ marginBottom: 5 }}>
                            <i className="fa fa-download hidden-xs"></i> Exportar
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                }
              />
            </Col>
            <Col md={8}>
              {this.state.calendarData &&
                <Card content={<div id="calendar" />} />
              }
            </Col>
          </Row>
        </Grid>
        {this.state.modalCreate &&
          <ModalCalendario
            closeModal={() => this.setState({modalCreate: false, currentCalendar: null})}
            saveCalendar={this.saveCalendar} userId={this.state.userId}
            calendario={this.state.currentCalendar} errorAlert={this.errorAlert}
          />
        }
        {this.state.modalEvent &&
          <ModalEvento
            closeModal={() => this.setState({modalEvent: false, daysAndTimes: null, currentEvent: null}, this.getAllDataAtOnce())}
            calendarServices={this.calendarServices} errorAlert={this.errorAlert}
            daysAndTimes={this.state.daysAndTimes} evento={this.state.currentEvent}
            userId={this.state.userId}
          />
        }
        {this.state.modalExport &&
          <ModalExport
            calendariosList={this.state.calendariosUser}
            closeModal={() => this.setState({modalExport: false})}
            errorAlert={this.errorAlert} exportCalendar={this.exportCalendar}
          />
        }
        {this.state.modalImport &&
          <ModalImport
            calendarServices={this.calendarServices} errorAlert={this.errorAlert}
            closeModal={() => this.setState({modalImport: false})}
            importCalendar={this.importCalendar}
          />
        }
      </div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/views/Calendar/Calendar.jsx